const code = {
  namespaced: true,
  state: {
    codeObj: {
      testCode: [
        {
          code: "1",
          name: "测试编码1"
        },
        {
          code: "2",
          name: "测试编码2"
        },
        {
          code: "3",
          name: "测试编码3"
        },
        {
          code: "4",
          name: "测试编码4"
        }
      ],
      // 查封顺位
      seizureOrderCode: [
        {
          code: "1",
          name: "首封"
        },
        {
          code: "2",
          name: "第一轮候"
        },
        {
          code: "3",
          name: "第二轮候"
        },
        {
          code: "4",
          name: "第三轮候"
        },
        {
          code: "5",
          name: "第四轮候"
        },
        {
          code: "6",
          name: "第五轮候"
        }
      ],
      // 币种
      currency: [
        {
          currencyTypeCn: "人民币",
          currencyTypeEn: "China Yuan",
          currencyCode: "CNY",
          currencySymbol: "￥",
          exchangeRate: 1
        },
        {
          currencyTypeCn: "美元",
          currencyTypeEn: "U S DOLLAR",
          currencyCode: "USD",
          currencySymbol: "$",
          exchangeRate: 6.49
        },
        {
          currencyTypeCn: "欧元",
          currencyTypeEn: "EURUSD",
          currencyCode: "EUR",
          currencySymbol: "€",
          exchangeRate: 7.81
        },
        {
          currencyTypeCn: "日元",
          currencyTypeEn: "JAPANESE YEN",
          currencyCode: "JPY",
          currencySymbol: "J￥",
          exchangeRate: 0.06
        },
        {
          currencyTypeCn: "港元",
          currencyTypeEn: "HONGKONG DILLAR",
          currencyCode: "HKD",
          currencySymbol: "$",
          exchangeRate: 0.84
        },
        {
          currencyTypeCn: "英镑",
          currencyTypeEn: "POUND STERLING",
          currencyCode: "GBP",
          currencySymbol: "￡",
          exchangeRate: 9.04
        },
        {
          currencyTypeCn: "澳元",
          currencyTypeEn: "Australian Dollar",
          currencyCode: "AUD",
          currencySymbol: "",
          exchangeRate: 5.03
        },
        {
          currencyTypeCn: "新西兰元",
          currencyTypeEn: "New Zealand dollar",
          currencyCode: "NZD",
          currencySymbol: "",
          exchangeRate: 4.67
        },
        {
          currencyTypeCn: "新加坡元",
          currencyTypeEn: "Singapore Dollar",
          currencyCode: "SGD",
          currencySymbol: "S$",
          exchangeRate: 4.88
        },
        {
          currencyTypeCn: "瑞士法郎",
          currencyTypeEn: "Swiss franc",
          currencyCode: "CHF",
          currencySymbol: "",
          exchangeRate: 7.08
        },
        {
          currencyTypeCn: "加元",
          currencyTypeEn: "Canadian Dollar",
          currencyCode: "CAD",
          currencySymbol: "",
          exchangeRate: 5.19
        },
        {
          currencyTypeCn: "马来西亚林吉特",
          currencyTypeEn: "MYR",
          currencyCode: "MYR",
          currencySymbol: "",
          exchangeRate: 1.58
        },
        {
          currencyTypeCn: "俄罗斯卢布",
          currencyTypeEn: "RUB",
          currencyCode: "RUB",
          currencySymbol: "руб",
          exchangeRate: 0.08
        },
        {
          currencyTypeCn: "南非兰特",
          currencyTypeEn: "RUB",
          currencyCode: "RUB",
          currencySymbol: "R",
          exchangeRate: 0.46
        },
        {
          currencyTypeCn: "韩元",
          currencyTypeEn: "Korean Won",
          currencyCode: "KRW",
          currencySymbol: "₩",
          exchangeRate: 0.01
        },
        {
          currencyTypeCn: "阿联酋迪拉姆",
          currencyTypeEn: "AED",
          currencyCode: "AED",
          currencySymbol: "",
          exchangeRate: 1.77
        },
        {
          currencyTypeCn: "沙特里亚尔",
          currencyTypeEn: "SAR",
          currencyCode: "SAR",
          currencySymbol: "",
          exchangeRate: 1.73
        },
        {
          currencyTypeCn: "匈牙利福林",
          currencyTypeEn: "HUF",
          currencyCode: "HUF",
          currencySymbol: "Ft",
          exchangeRate: 0.02
        },
        {
          currencyTypeCn: "波兰兹罗提",
          currencyTypeEn: "PLN",
          currencyCode: "PLN",
          currencySymbol: "",
          exchangeRate: 1.71
        },
        {
          currencyTypeCn: "丹麦克朗",
          currencyTypeEn: "DKK",
          currencyCode: "DKK",
          currencySymbol: "kr",
          exchangeRate: 1.05
        },
        {
          currencyTypeCn: "瑞典克朗",
          currencyTypeEn: "SEK",
          currencyCode: "SEK",
          currencySymbol: "kr",
          exchangeRate: 0.77
        },
        {
          currencyTypeCn: "挪威克朗",
          currencyTypeEn: "NOK",
          currencyCode: "NOK",
          currencySymbol: "kr",
          exchangeRate: 0.78
        },
        {
          currencyTypeCn: "土耳其里拉",
          currencyTypeEn: "TRY",
          currencyCode: "TRY",
          currencySymbol: "",
          exchangeRate: 0.79
        },
        {
          currencyTypeCn: "墨西哥比索",
          currencyTypeEn: "MXN",
          currencyCode: "MXN",
          currencySymbol: "",
          exchangeRate: 0.33
        },
        {
          currencyTypeCn: "泰铢",
          currencyTypeEn: "บาท",
          currencyCode: "THB",
          currencySymbol: "฿ ",
          exchangeRate: 0.21
        }
      ],
      // 资产类型
      assetTypes: [
        // {
        //     "id": "zhinan",
        //     "name": "权力",
        //     "children": [
        //         {
        //             "id": "shejiyuanze",
        //             "name": "股权",
        //             "children": null,
        //         },
        //         {
        //             "id": "daohang",
        //             "name": "债权",
        //             "children": [
        //                 {
        //                     "id": "cexiangdaohang",
        //                     "name": "应收账款"
        //                 },
        //                 {
        //                     "id": "dingbudaohang",
        //                     "name": "欠款"
        //                 }
        //             ]
        //         }
        //     ]
        // },
        // {
        //     "id": "zujian",
        //     "name": "动产",
        //     "children": [
        //         {
        //             "id": "basic",
        //             "name": "生产线"
        //         }
        //     ]
        // }
      ]
    }
  },
  // 文件图标
  fileIcon: [
    {
      code: 1,
      name: "code",
      icon: "icon-div-1"
    },
    {
      code: 2,
      name: "word",
      icon: "icon-word-1"
    },
    {
      code: 3,
      name: "ppt",
      icon: "icon-ppt-1"
    },
    {
      code: 4,
      name: "png",
      icon: "icon-png-1"
    },
    {
      code: 5,
      name: "txt",
      icon: "icon-txt-1"
    },
    {
      code: 6,
      name: "excel",
      icon: "icon-excel-1"
    },
    {
      code: 7,
      name: "docx",
      icon: "icon-wendang-docx_doc"
    },
    {
      code: 8,
      name: "pdf",
      icon: "icon-PDF"
    },
    {
      code: 9,
      name: "jpg",
      icon: "icon-JPG"
    },
    {
      code: 10,
      name: "mp3",
      icon: "icon-mp3-1"
    },
    {
      code: 11,
      name: "zip",
      icon: "icon-zip-1"
    },
    {
      code: 12,
      name: "mp4",
      icon: "icon-MP4"
    },
    {
      code: 13,
      name: "folder",
      icon: "icon-wenjianjia"
    },
    {
      code: 14,
      name: "xls",
      icon: "icon-XLS"
    },
    {
      code: 15,
      name: "xlxs",
      icon: "icon-biaoge-xlxs_xls"
    },
    {
      code: 16,
      name: "rar",
      icon: "icon-yasuowenjian-zip_rar_7z"
    },
    {
      code: 17,
      name: "psd",
      icon: "icon-PSD"
    },
    {
      code: 18,
      name: "cad",
      icon: "icon-CAD"
    },
    {
      code: 19,
      name: "ios",
      icon: "icon-jingxiangwenjian-iso"
    },
    {
      code: 20,
      name: "exe",
      icon: "icon-kezhihangwenjian-exe"
    },
    {
      code: 21,
      name: "apk",
      icon: "icon-apk1"
    },
    {
      code: 22,
      name: "css",
      icon: "icon-css"
    },
    {
      code: 23,
      name: "7z",
      icon: "icon-a-7z"
    },
    {
      code: 24,
      name: "", // 没有后缀用这个图标
      icon: "icon-1"
    },
    {
      code: 25,
      name: "vue",
      icon: "icon-vue"
    },
    {
      code: 26,
      name: "js",
      icon: "icon-JS"
    },
    {
      code: 27,
      name: "eps",
      icon: "icon-AVI"
    },
    {
      code: 28,
      name: "html",
      icon: "icon-html"
    },
    {
      code: 29,
      name: "htm",
      icon: "icon-html"
    },
    {
      code: 30,
      name: "sql",
      icon: "icon-SQL"
    },
    {
      code: 31,
      name: "json",
      icon: "icon-JSON"
    },
    {
      code: 32,
      name: "g",
      icon: "icon-gradle"
    },
    {
      code: 33,
      name: "svg",
      icon: "icon-SVG"
    },
    {
      code: 34,
      name: "jar",
      icon: "icon-jar"
    },
    {
      code: 35,
      name: "java",
      icon: "icon-jar"
    },
    {
      code: 36,
      name: "xml",
      icon: "icon-XML"
    },
    {
      code: 37,
      name: "kml",
      icon: "icon-kmk"
    },
    {
      code: 38,
      name: "jsx",
      icon: "icon-jsx"
    },
    {
      code: 39,
      name: "php",
      icon: "icon-php"
    },
    {
      code: 40,
      name: "pom",
      icon: "icon-pom"
    },
    {
      code: 41,
      name: "py",
      icon: "icon-py"
    },
    {
      code: 42,
      name: "sass",
      icon: "icon-scss"
    },
    {
      code: 43,
      name: "scss",
      icon: "icon-scss"
    },
    {
      code: 44,
      name: "doc",
      icon: "icon-wendang-docx_doc"
    }
  ],
  mutations: {
    SET_CODE_LIST: (state, { field, list }) => {
      state.codeObj[field] = list || [];
    },
    GET_CODE_LIST: (state, field) => {
      if (state.codeObj[field] && state.codeObj[field].length) {
        return state.codeObj[field];
      }
      return null;
    }
  },
  actions: {
    // 用于请求接口获取编码表
    // 初始化资产类型
    // initAssetType({ commit }) {
    //   getAssetTypeList().then(res => {
    //     commit("SET_CODE_LIST", { field: "assetTypes", list: res.data || [] });
    //   });
    // },
    // 初始化编码
    // initCodes({ commit }, type) {
    //   return getDictionaryTableData(type).then(res => {
    //     commit("SET_CODE_LIST", { field: type, list: res.data || [] });
    //   });
    // }
  }
};

export default code;
